import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { from } from 'rxjs';
import { PublicTenantService } from '../services/public-tenant.service';

export const storyblokPublicTenantResolver = (route: ActivatedRouteSnapshot) => {
  const publicTenantService = inject(PublicTenantService);

  if (route.queryParams.tenant) {
    return from(publicTenantService.getTenant(route.queryParams.tenant));
  }
};
